import { useLanguage } from '../context/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer data-testid="footer" className="bg-card border-t border-border py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <span className="font-heading text-2xl tracking-wider text-foreground">OKI-<span className="text-brand">ESCAPE</span></span>
            <p className="font-sans text-sm text-muted-foreground mt-1">{t('footerTagline')}</p>
          </div>
          <div className="flex items-center gap-6">
            <a href="mailto:info@okiescape.com" data-testid="footer-email" className="font-sans text-sm text-muted-foreground hover:text-brand transition-colors">info@okiescape.com</a>
            <a href="tel:098-989-0319" data-testid="footer-phone" className="font-sans text-sm text-muted-foreground hover:text-brand transition-colors">098-989-0319</a>
            <a href="http://facebook.com/okiescape" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="font-sans text-sm text-muted-foreground hover:text-brand transition-colors">Facebook</a>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-border text-center">
          <p className="font-sans text-xs text-muted-foreground">&copy; {new Date().getFullYear()} Oki-Escape. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
